import "./nav.js";
import "./header.js";
import "./blocks/accordion.js";
import "./blocks/screenshots-phone-mobile.js";
import "./blocks/sticky-watch.js";
import "./blocks/sticky-watch-mobile.js";
import "./blocks/sticky-phone.js";
import "./blocks/sticky-phone-mobile.js";
import "./blocks/sticky-performance-peaks.js";
import "./blocks/sticky-performance-peaks-mobile.js";
import "./blocks/sticky-pyramid.js";
import "./blocks/pricing-plans.js";
import "./blocks/landing.js";
